import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { QRCodeCanvas } from 'qrcode.react';
import { Modal, Button } from '../../../../components';
import { modalClose } from '../../../../layout/redux/layoutActions';

/**
 * QrcodeAmazon component
 * Props:
 *  - url: string | null          URL to encode in QR code
 *  - nomeItem: string            Name used for filename
 *  - title: string               Modal title
 *  - texto: string               Instruction text above QR
 *  - textoSemUrl: string         Text when no URL available
 */
export default function QrcodeAmazon({ url, nomeItem, title, texto, textoSemUrl }) {
  const dispatch = useDispatch();
  const { statusModal } = useSelector(state => state.layoutState);

  // sanitize name for file
  const sanitizeNomeArquivo = (nome) => {
    if (typeof nome !== 'string' || !nome.trim()) return 'item';
    return nome
      .normalize('NFD')
      .replace(/[̀-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9]/g, '_');
  };

  const canvasId = `qrcode-amazon-canvas-${sanitizeNomeArquivo(nomeItem)}`;

  const downloadQRCode = () => {
    const canvas = document.getElementById(canvasId);
    if (!canvas) return;
    const pngUrl = canvas
      .toDataURL('image/png')
      .replace('image/png', 'application/octet-stream');
    const link = document.createElement('a');
    link.href = pngUrl;
    link.download = `qrcode_amazon_${sanitizeNomeArquivo(nomeItem)}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Modal
      name="qrcode-amazon"
      title={title}
      size="medium"
      open={statusModal === 'qrcode-amazon'}
      close={() => dispatch(modalClose())}
      closeText="Fechar"
    >
      <div style={{ textAlign: 'center' }}>
        <p style={{ marginBottom: 20 }}>{texto}</p>
        {url ? (
          <QRCodeCanvas
            key={url}
            id={canvasId}
            value={url}
            size={400}
          />
        ) : (
          <p>{textoSemUrl}</p>
        )}
        <div style={{ marginTop: 20 }}>
          <Button
            color="primary"
            variant="outlined"
            onClick={downloadQRCode}
            disabled={!url}
          >
            Download
          </Button>
        </div>
      </div>
    </Modal>
  );
}
